import axios from 'axios';

import type { IGeocodeJSONFeature } from '@/types/address';

export const addressDataGouvRequest = async (
	search: string
): Promise<IGeocodeJSONFeature[]> => {
	if (!search || search.length < 3) return [];
	const encodedSearch = encodeURIComponent(search.trim());
	const response = await axios.get(
		`https://data.geopf.fr/geocodage/search/?q=${encodedSearch}`
	);
	return response.data?.features ?? [];
};

export const fetchPostcodeFromCity = async (
	city: string
): Promise<string | null> => {
	if (!city || city.length < 2) return null;
	const encodedSearch = encodeURIComponent(city.trim());
	const response = await axios.get(
		`https://data.geopf.fr/geocodage/search/?q=${encodedSearch}&type=municipality&limit=1`
	);
	const features = response.data?.features ?? [];
	if (!features.length) return null;
	return features[0]?.properties?.postcode ?? null;
};

export interface CityLocation {
	postcode: string | null;
	longitude: number | null;
	latitude: number | null;
}

export const fetchCityLocation = async (
	city: string
): Promise<CityLocation> => {
	if (!city || city.length < 2)
		return { postcode: null, longitude: null, latitude: null };
	const encodedSearch = encodeURIComponent(city.trim());
	const response = await axios.get(
		`https://data.geopf.fr/geocodage/search/?q=${encodedSearch}&type=municipality&limit=1`
	);
	const features = response.data?.features ?? [];
	if (!features.length)
		return { postcode: null, longitude: null, latitude: null };
	const feature: IGeocodeJSONFeature = features[0];
	const postcode = feature.properties?.postcode ?? null;
	const [longitude, latitude] = feature.geometry?.coordinates ?? [null, null];
	return { postcode, longitude: longitude ?? null, latitude: latitude ?? null };
};
